import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../../components/button/constants';
import FormBoxesCard from '../../../../../components/card/formboxescard/FormBoxesCard';
import { HEADING } from '../../../../../components/heading/constants/constants';
import Heading from '../../../../../components/heading/Heading';
import { componentKey, setTempFormFieldsList } from '../../CreateFormSlice';
import styles from './FederalInformation.styles';
import { CREATE_FORMS_LOADING_STATES, CREATE_FORM_STATES_MESSAGE_MAP, FORM_STEP } from '../../constants';
import RenderFields from '../components/RenderFields';
import RenderInteractionElement from '../components/RenderInteractionElement';
import Loadable from '../../../../../components/loadable/Loadable';

export default function FederalInformation() {
    const { loadingState, formFieldsList, toCreateFormData, tempFormFieldsList, formsPreLoadedData, onDependentFields, userInteractionPopupWResponseObj } = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();
    const [groupedFields, setGroupedFields] = useState([]);

    useEffect(() => {
        handleSelectAllorNone(true);
    }, [])

    useEffect(() => {
        const grouped = {};
        tempFormFieldsList.forEach((field) => {
            if (field?.Category === FORM_STEP.FEDERAL){
                if(field?.GroupId){
                    const groupId = field.GroupId;
                    if (!grouped[groupId]) {
                        grouped[groupId] = [field];
                    } else {
                        grouped[groupId].push(field);
                    }
                }
            }
        });

        const groupedFieldsArr = Object.values(grouped);
        tempFormFieldsList.forEach((field) => {
            if(field?.Category === FORM_STEP.FEDERAL){
                if (!field.GroupId) {
                    groupedFieldsArr.push([field]);
                }
            }
        });
        
        groupedFieldsArr.sort((a, b) => {
            const boxA = a[0].BoxInfo.Box;
            const boxB = b[0].BoxInfo.Box;

            // Extract the numerical and non-numerical parts from the Box values
            const numA = parseInt(boxA);
            const numB = parseInt(boxB);
            const nonNumA = boxA.replace(/^\d+/, '');
            const nonNumB = boxB.replace(/^\d+/, '');

            if (numA === numB) {
                return nonNumA.localeCompare(nonNumB);
            } else {
                return numA - numB;
            }
        });
        setGroupedFields(groupedFieldsArr);
    }, [tempFormFieldsList]);

    const handleFormBoxSelection = (groupId = null, selectedField) => {
        const updatedBoxesList = tempFormFieldsList.map((item) => {
            if (item?.Category === FORM_STEP.FEDERAL) {
                if (item.GroupId === groupId || selectedField?.Name === item.Name) {
                    return {
                        ...item,
                        isSelected: !item.isSelected,
                    };
                }
            }
            return item;
        });
        dispatch(setTempFormFieldsList(updatedBoxesList));
    };

    const handleSelectAllorNone = (selection) => {
        const updatedBoxesList = tempFormFieldsList.map((item) => {
            if (item.Category === FORM_STEP.FEDERAL) {
                return {
                    ...item,
                    isSelected: selection,
                };
            }
            return item;
        });
        dispatch(setTempFormFieldsList(updatedBoxesList));
    };

    return (
        <>
            <div style={styles.mainContainer}>
                <div style={styles.titleRow}>
                    <div style={styles.headerTitle}>
                        <Heading type={HEADING.H1}>
                            Let’s start with eFiling federal information
                        </Heading>
                        <div style={styles.titleSubTextContainer}>
                            <span style={styles.titleSubText}>
                                Please select the boxes to fill in the details.
                            </span>
                            <span>
                                <Button
                                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                    onClickCb={() => handleSelectAllorNone(true)}
                                >
                                    Select all
                                </Button>
                            </span>
                            <span style={styles.selectAllNoneSpace}>/</span>
                            <span>
                                <Button
                                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                    onClickCb={() => handleSelectAllorNone(false)}
                                >
                                    Select none
                                </Button>
                            </span>
                        </div>
                    </div>
                </div>
                <Loadable
                    currentState={loadingState.state} 
                    messageMap={CREATE_FORM_STATES_MESSAGE_MAP}
                    loadingStates={[CREATE_FORMS_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING, CREATE_FORMS_LOADING_STATES.SAVING_FORM_LOADING]} 
                    isNewLoadable={true}
                    preserveChildMount={true}
                >
                    <div style={styles.boxListContainer}>
                        <div style={styles.boxListRow}>
                            <div style={styles.tobeSelectedBoxesContainer}>
                                {groupedFields.map((group, index) => (
                                    <div key={index} style={styles.formBox}>
                                        <FormBoxesCard
                                            boxCheckbox={{
                                                showCheckbox: true,
                                                isChecked: group.filter(elm => elm.isSelected)?.length ? true : false,
                                                onChangeCb: () => handleFormBoxSelection(group[0]?.GroupId ?? null, group[0]),
                                            }}
                                            isBlurred={false}
                                            boxData={{
                                                boxLabel: group[0]?.GroupLabel !== "" ? group[0]?.GroupLabel : group[0].Label,
                                                boxNumber: group[0]?.BoxInfo?.Box ?? "",
                                                formBox: group[0],
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                            <div style={styles.selectedBoxesValuesContainer}>
                                <RenderFields step={FORM_STEP.FEDERAL} tempFormFieldsList={tempFormFieldsList} formsPreLoadedData={formsPreLoadedData} toCreateFormData={toCreateFormData} onDependentFields={onDependentFields} />
                            </div>
                        </div>
                    </div>
                </Loadable>
            </div>
            {
                (userInteractionPopupWResponseObj?.type) ? <RenderInteractionElement interactionObj={userInteractionPopupWResponseObj} userInteractionPopupWResponseObj={userInteractionPopupWResponseObj} /> : ""
            }
        </>
    );
}
